<template>
  <page-section :section-name="name" :content="textContent">
    <template #header="{ content }">
      <div class="text-shadow header-content relative container mb-5 mx-auto">
        <img
          src="../assets/images/Photos/Honouring_human_rights_defenders/img_0661.jpg"
          :alt="$t('i18nAlt[34]')"
        />
        <div class="absolute bottom-0 left-0 p-6 text-center">
          <fade-shift ratio="0.75">
            <h2 class="text-white lowercase" v-html="content.title" />
          </fade-shift>
        </div>
      </div>
    </template>
    <template v-slot="{ content }">
      <p
        v-for="(string, index) in content.body"
        :key="`${name}-${index}`"
        v-html="string"
        :class="{
          lead: index === 0,
        }"
      />
    </template>
  </page-section>
</template>

<script>
export default {
  name: "HonouringHumanRightsDefenders",
  components: {
    pageSection: () => import("@/components/PageSection.vue"),
    fadeShift: () => import("@/components/FadeShift.vue"),
  },
  data() {
    return {
      name: "honouringHumanRightsDefenders",
    };
  },
  computed: {
    textContent() {
      const { name } = this;

      return this.$t(`i18nSections.${name}`);
    },
  },
};
</script>
